/**
 * Emergency authentication reset utility
 * Use this if authentication gets stuck in a redirect loop
 */

export const resetAuthenticationState = () => {
  console.log("Resetting authentication state...");

  // Clear all session storage auth-related items
  sessionStorage.removeItem("auth-method");
  sessionStorage.removeItem("login-in-progress");
  sessionStorage.removeItem("login-start-time");
  sessionStorage.removeItem("backend-unavailable");
  sessionStorage.removeItem("auth-completed");
  sessionStorage.removeItem("auth-completed-time");
  sessionStorage.removeItem("last-redirect-time");
  sessionStorage.removeItem("last-navigate-time");
  sessionStorage.removeItem("last-successful-auth");
  sessionStorage.removeItem("logout-in-progress");

  // Clear local storage auth items
  localStorage.removeItem("bestekJwtToken");

  // Clear MSAL cache (this will force re-authentication)
  const msalKeys = Object.keys(sessionStorage).filter(
    (key) => key.startsWith("msal.") || key.startsWith("cc-")
  );

  msalKeys.forEach((key) => {
    sessionStorage.removeItem(key);
  });

  console.log("Authentication state reset complete. Reloading page...");

  // Reload the page to start fresh
  window.location.href = "/login";
};

// Initialize clean state for first-time users
export const initializeAuthState = () => {
  // Check if this is truly a first-time user (no auth-related storage)
  const hasAuthData =
    sessionStorage.getItem("auth-method") ||
    sessionStorage.getItem("last-redirect-time") ||
    sessionStorage.getItem("last-successful-auth") ||
    localStorage.getItem("bestekJwtToken");

  if (!hasAuthData) {
    // First-time user - ensure clean state
    sessionStorage.setItem("auth-method", "none");
    console.log("Initialized clean auth state for first-time user");
  }
};

// Auto-initialize on import for first-time users
if (typeof window !== "undefined") {
  initializeAuthState();
}

// Make it available globally for emergency use
if (typeof window !== "undefined") {
  (window as typeof window & { resetAuth?: () => void }).resetAuth =
    resetAuthenticationState;
}
